import React from "react";
import { Typography } from "@mui/material";
import SyledInfoContnet from "./styles";

const InfoContent = ({ content }) => {
  return (
    <SyledInfoContnet>
      <div className="info-content">
        <div className="info-content-line info-content-line--left">
          <div className="info-content-line-content" />
        </div>

        <div className="info-content-text">
          <Typography variant="caption">{content}</Typography>
        </div>

        <div className="info-content-line">
          <div className="info-content-line-content info-content-right" />
        </div>
      </div>
    </SyledInfoContnet>
  );
};

export default InfoContent;
